/**
 * RequireAuth — Clerk-backed route gate.
 *
 * S-055 / FEAT-006. Replaces the previous Directus token-check guard
 * with Clerk's `<SignedIn>` / `<SignedOut>` primitives. While Clerk is
 * still hydrating its session, render the existing boot screen so the
 * shell doesn't flash an unauthenticated state.
 */

import { RedirectToSignIn, SignedIn, SignedOut, useAuth } from "@clerk/clerk-react";

export function RequireAuth({ children }: { children: React.ReactElement }) {
  const { isLoaded } = useAuth();

  if (!isLoaded) {
    return (
      <div className="boot-screen">
        <span className="brand-mark">◈</span>
        <span>Loading…</span>
      </div>
    );
  }

  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}
